import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { useAppDispatch, useAppSelector } from '../../../hooks';
import { addFundraisingCampaignAmbassador, inviteFundraisingAmbassador } from '../../../managers/redux/slices/fundraising';

// mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import isEmail from 'validator/lib/isEmail'
import { COLORS } from '../../../theme/muiTheme';
import { StaffProfile, FundraisingProfile } from '../../../API';
import FundraisingProfileSelector from '../../inputs/FundraisingProfileSelector';

interface AddCampaignAmbassadorDialogProps {
    visible: boolean
    onClose: () => void
}

export default function AddCampaignAmbassadorDialog(props: AddCampaignAmbassadorDialogProps) {

    const dispatch = useAppDispatch()
    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)

    useEffect(() => {
        setVisible(props.visible)
    }, [props.visible])

    function handleClose() {
        setVisible(false)
        setFundraisingProfile(null)
        props.onClose()
    }

    const [visible, setVisible] = useState(false)
    const [email, setEmail] = useState<null | string>(null)
    const [fundraisingProfile, setFundraisingProfile] = useState<FundraisingProfile | null>(null)

    async function _handleClick() {
        if (fundraisingProfile) {
            const addFundraisingCampaignAmbassadorResponse = await dispatch(addFundraisingCampaignAmbassador({
                fundraisingAmbassador: fundraisingProfile
            }))
            handleClose()
        } else {
            toast.error(`You must select an ${selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverrideSingular : 'Ambassador'} first.`, { containerId: 'main' })
        }
    }

    return (
        <div>
            <Dialog
                open={visible}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="md"
                fullWidth
            >
                <div className="p-4">
                    <DialogContent>
                        <Typography variant="h3">Add a campaign {selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverrideSingular : 'Ambassador'}</Typography>
                        <Typography variant="body1">Invite an {selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverrideSingular : 'Ambassador'} to your campaign</Typography>

                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <FundraisingProfileSelector
                                onChange={(selectedFundraisingProfile: FundraisingProfile | null) => {
                                    setFundraisingProfile(selectedFundraisingProfile)
                                }}
                                value={fundraisingProfile}
                                label={`Select ${selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.ambassadorTermOverrideSingular ? selectedStaffProfile.organization.ambassadorTermOverrideSingular : 'Ambassador'}`}
                                className="my-3"
                            />
                            <Button
                                onClick={_handleClick}
                                variant="outlined"
                                disabled={fundraisingProfile == null}
                                fullWidth
                            >
                                Add to campaign
                            </Button>
                        </div>
                    </DialogContent>
                </div>
                <DialogActions className="mt-3">
                    <Button onClick={() => handleClose()}>Close</Button>
                    {/* <Button
                        onClick={_handleClick}
                        variant="contained"
                        disabled={email != '' && email != null && !isEmail(email)}
                    >
                        Send Invitation
                    </Button> */}
                </DialogActions>
            </Dialog>
            <div id="map"></div>
        </div>
    )
}